import { Deserializable } from "@app/interfaces/deserializable";

export class VoiceConnectionDetails implements Deserializable {

    dial_action: string;
    customerDial: string;
    customerName: string;
    monexRep: string;
   

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}